import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/revPilot")({
  component: RevPilotLayout,
});

function RevPilotLayout() {
  return <Outlet />;
}
